"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function generateTinestampFolder() {
    return Math.floor(Date.now() / 1000).toString();
}
exports.generateTinestampFolder = generateTinestampFolder;
//# sourceMappingURL=utils.js.map